import { Flex, Form, FormTextField, PaperSection } from '@shared/components';

import { QuestionReviewTaskCreationFormProvider } from '../../providers';
import { AddQuestionSection } from '../add-question-section';
import { ConfirmAndAddAssigneeButton } from '../confirm-and-add-assignee-button';
import { TaskDetailSection } from '../task-detail-section';

export default function QuestionReviewTaskDetail() {
  return (
    <QuestionReviewTaskCreationFormProvider>
      <Form>
        <PaperSection
          title='Task Information'
          sx={(theme) => ({ mb: theme.spacing(6), borderRadius: theme.spacing(2) })}
        >
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              gap: theme.spacing(6),
              p: theme.spacing(6),
            })}
          >
            <FormTextField
              name='taskName'
              label='Task Name'
              placeholder='กรุณากรอก Task Name'
              required
            />
          </Flex>
        </PaperSection>
        <PaperSection
          title='Question Details'
          sx={(theme) => ({ mb: theme.spacing(6), borderRadius: theme.spacing(2) })}
        >
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              gap: theme.spacing(6),
              p: theme.spacing(6),
            })}
          >
            <TaskDetailSection />
            <AddQuestionSection />
          </Flex>
        </PaperSection>
        <ConfirmAndAddAssigneeButton />
      </Form>
    </QuestionReviewTaskCreationFormProvider>
  );
}
